module.exports = __webpack_public_path__ + "static/media/Vacc1.fc9cbedd.webp";